import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from 'web-library';
import { useUserDetails } from '../../../hooks/userDetails';
import { Role } from '../../../models';

export interface PaymentErrorModalProps {
  modelOpen: boolean;
  uniqueLink: boolean;
  onClickModalButton: () => void;
  closeAllModels: {
    isErrorModalOpen: boolean;
    callback: () => void;
  };
  errorMessages?: string[];
  isRetry?: boolean;
  buttonText: string;
}

const PaymentErrorModal = ({
  isRetry,
  modelOpen,
  uniqueLink = false,
  onClickModalButton,
  errorMessages = [],
  closeAllModels,
  buttonText,
}: PaymentErrorModalProps) => {
  const { data: userDetails } = useUserDetails();
  const { isErrorModalOpen, callback } = closeAllModels;
  useEffect(() => {
    if (isErrorModalOpen) {
      callback();
    }
  }, [isErrorModalOpen, callback]);

  const renderErrorMessage = () => {
    if (userDetails?.data?.roles?.includes(Role.candidate)) {
      return (
        'Payment status currently pending verification at eNETS. Please contact SEAB or view your application status after 15min.' +
        ' An email will be sent to you within 15min on your application status.'
      );
    }

    if (userDetails?.data?.roles?.includes(Role.coordinator)) {
      return (
        'Payment status currently pending verification at eNETS. Please contact SEAB.' +
        ' An email will be sent to you within 15min on your application status.'
      );
    }
    return '';
  };

  const getButtonText = () => {
    if (typeof isRetry === 'boolean' && !isRetry) {
      return uniqueLink ? 'Close' : buttonText;
    }
    return 'Retry';
  };

  return (
    <Dialog open={modelOpen} maxWidth="sm" state="error">
      <DialogContent>
        {typeof isRetry === 'boolean' && isRetry === false && (
          <DialogContentText>{renderErrorMessage()}</DialogContentText>
        )}
        {errorMessages.map((errorMsg) => (
          <DialogContentText key={errorMsg}>{errorMsg}</DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          id="button-retry"
          type="button"
          variant="text"
          color="secondary"
          onClick={onClickModalButton}
        >
          {getButtonText()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentErrorModal;
